import { useEffect, useState } from "react";
import { Col, Row, Form, Button, Spinner } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import { Link } from "react-router-dom";
import axios from "axios";
import RescueTableComponent from "../../../components/tables/RescueTableComponent";
import PulseLoader from "react-spinners/PulseLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
export default function AllRescuedFamilies() {
	const [formState, setFormState] = useState({
		from_date: "",
		to_date: "",
	});
	const [error, setError] = useState("");
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const AuthToken = localStorage.getItem("AuthUser");
	const location = useLocation();
	const navigate = useNavigate();
	const { pathname, search } = useLocation();
	const roleId = JSON.parse(localStorage.getItem("user")).role_id;
	const [familyDonor, setFamilyDonor] = useState([]);

	useEffect(() => {
		if (roleId === 1) {
			const fetchData = async () => {
				try {
					axios.defaults.headers.common[
						"Authorization"
					] = `Bearer ${AuthToken}`;
					const response = await axios.get(
						process.env.REACT_APP_API_URL + "/family-donors"
					);
					setFamilyDonor(response.data.donors);
					console.log("user roles", response.data.donors);
				} catch (error) {
					console.error("Error fetching data:", error);
				}
			};
			fetchData();
		}
	}, [roleId, AuthToken]);

	const [pagination, setPagination] = useState({
		current_page: 1,
		last_page: 1,
		next_page_url: null,
		prev_page_url: null,
		total: 0,
		required_page: 1,
	});
	const handleChange = (e) => {
		const { name, value } = e.target;
		const updatedState = {
			...formState,
			[name]: value,
		};
		setFormState(updatedState);
		console.log("updatedState", updatedState);
		const { from_date, to_date } = updatedState;
		if (
			(from_date &&
				to_date &&
				new Date(to_date) >= new Date(from_date)) ||
			(!from_date && !to_date)
		) {
			setError("");
		}
	};

	const handleApplyFilter = async () => {
		const { from_date, to_date } = formState;
		if (!from_date && !to_date) {
			setError("Please enter from_date and to_date.");
			return;
		}
		if (from_date && !to_date) {
			setError("Please select a 'To Date' when 'From Date' is chosen.");
			return;
		}
		if (!from_date && to_date) {
			setError("Please select a 'From Date' when 'To Date' is chosen.");
			return;
		}
		if (from_date && to_date && new Date(to_date) < new Date(from_date)) {
			setError("'To Date' cannot be earlier than 'From Date'.");
			return;
		}

		setError("");
		setLoading(true);
		try {
			axios.defaults.headers.common[
				"Authorization"
			] = `Bearer ${AuthToken}`;
			const params = {};
			if (formState?.from_date) params.from_date = formState.from_date;
			if (formState?.to_date) params.to_date = formState.to_date;
			const response = await axios.get(
				`${process.env.REACT_APP_API_URL}/rescue-list`,
				{ params }
			);
			setData(response.data.peoples.data);
		} catch (error) {
			console.error("Error applying filter:", error);
		} finally {
			setLoading(false);
		}
	};

	const handleClearFilter = async () => {
		setLoading(true);
		try {
			setFormState({ from_date: "", to_date: "" });
			setError("");
			axios.defaults.headers.common[
				"Authorization"
			] = `Bearer ${AuthToken}`;
			const response = await axios.get(
				`${process.env.REACT_APP_API_URL}/rescue-list`
			);
			setData(response.data.peoples.data);
		} catch (error) {
			console.error("Error clearing filter:", error);
		} finally {
			setLoading(false);
		}
	};

	const fetchData = async (page, filters = {}) => {
		const currentPage = page || pagination.current_page || 1;

		setLoading(true);
		try {
			axios.defaults.headers.common[
				"Authorization"
			] = `Bearer ${AuthToken}`;
			const params = { page: currentPage, ...filters };
			const response = await axios.get(
				`${process.env.REACT_APP_API_URL}/rescue-list`,
				{ params }
			);
			console.log("rescued families", response.data.peoples.data);

			const peoples = response.data.peoples;
			setData(peoples.data || []);
			setPagination({
				current_page: peoples.current_page,
				last_page: peoples.last_page,
				next_page_url: peoples.next_page_url,
				prev_page_url: peoples.prev_page_url,
				total: peoples.total,
				required_page: peoples.current_page,
			});
		} catch (error) {
			console.error("Error fetching data:", error);
		} finally {
			setLoading(false);
		}
	};

	const handleRequiredPageChange = (e) => {
		const value = e.target.value;
		setPagination((prev) => ({ ...prev, required_page: value }));
	};
	const handlePageInputSubmit = () => {
		const page = Number(pagination.required_page);
		if (page >= 1 && page <= pagination.last_page) {
			fetchData(page, formState);
			navigate(`?page=${page}`);
			setError("");
		} else {
			setError(
				`Please enter a page number between 1 and ${pagination.last_page}`
			);
		}
	};
	useEffect(() => {
		const params = new URLSearchParams(location.search);
		const page = Number(params.get("page")) || 1;
		fetchData(page, formState);
	}, [location.search, formState]);

	const handlePageChange = (page) => {
		fetchData(page, formState);
		navigate(`?page=${page}`);
	};
	const mappedData = data.map((person) => ({
		id: person.id || "",
		fsf_id: person.f_number || "",
		donor_id: person.family_donor_id || "",
		beneficiary_cnic: person.cnic || "",
		beneficiary_name: person.beneficiary_name || "",
		family_donor: person.donor_name || "Not donor yet",
		partner_name: person.identifier?.name || "",
		organization_church: person.identifier?.org || "",
		verified_by: "Wasiq Rehman",
		family_donor_id: person.family_donor_id,

		progress: person.full_progress,
		action: {
			edit: "edit",
			delete: "delete",
			view: "visibility",
		},
	}));

	const onChangeRole = async (event, id) => {
		try {
			axios.defaults.headers.common[
				"Authorization"
			] = `Bearer ${AuthToken}`;
			const response = await axios.post(
				`${process.env.REACT_APP_API_URL}/update-family-donor-id/${id}`,
				{
					family_donor_id: event.target.value || null,
				}
			);
			if(response.data.success)
			{
				Swal.fire({
				title: "Success!",
				text: response.data.message,
				icon: "success",
				confirmButtonText: "Ok",
			});
			}
			
		} catch (error) {
			console.error("Error updating family donor:", error);
		}
	};

	return (
		<PageLayout>
			<Row>
				<Col xl={12}>
					<div className="mc-card">
						<div className="mc-breadcrumb">
							<h3 className="mc-breadcrumb-title">
								<i className="material-icons">factory</i>
								All Rescued Families
							</h3>
							<ul className="mc-breadcrumb-list">
								<li className="mc-breadcrumb-item">
									<Link
										to="/"
										className="mc-breadcrumb-link"
										style={{ color: "#077834" }}
									>
										Home
									</Link>
								</li>
								<li className="mc-breadcrumb-item">
									Rescued Families
								</li>
							</ul>
						</div>
					</div>
				</Col>
			</Row>

			<div className="mc-card p-3">
				<Row className="align-items-center g-3">
					<Col md="auto">
						<Form.Label className="mb-0">From:</Form.Label>
					</Col>
					<Col md={3}>
						<Form.Control
							name="from_date"
							type="date"
							value={formState.from_date}
							onChange={handleChange}
						/>
					</Col>
					<Col md="auto">
						<Form.Label className="mb-0">To:</Form.Label>
					</Col>
					<Col md={3}>
						<Form.Control
							name="to_date"
							type="date"
							value={formState.to_date}
							onChange={handleChange}
						/>
					</Col>
					<Col md="2">
						<Button
							onClick={handleApplyFilter}
							style={{
								backgroundColor: "#077834",
								fontWeight: "bold",
								fontSize: "12px",
							}}
						>
							Apply Filter
						</Button>
					</Col>
					<Col md="2">
						<Button
							onClick={handleClearFilter}
							className="bg-secondary"
							style={{ fontWeight: "bold", fontSize: "12px" }}
						>
							Clear Filter
						</Button>
					</Col>
				</Row>
				{error && (
					<div
						className="text-danger mt-2"
						style={{ fontSize: "13px" }}
					>
						{error}
					</div>
				)}
			</div>

			<div className="mc-card mt-3">
				<Row>
					<Col xl={12}>
						{loading ? (
							<div
								className="d-flex justify-content-center align-items-center"
								style={{ height: "40vh", gap: "8px" }}
							>
								<h3
									style={{
										color: "#077834",
										fontWeight: "bold",
										letterSpacing: "1px",
										marginBottom: "0",
									}}
								>
									Loading rescued families
								</h3>
								<PulseLoader
									color="#077834"
									loading={loading}
									size={6}
								/>
							</div>
						) : (
							<RescueTableComponent
								thead={
									roleId == 4
										? [
												"Beneficiary",
												"Family Donor",
												"Partner",
												"Verified By",
												"Status",
												"Progress",
												"Action",
										  ]
										: [
												"Beneficiary",
												"Partner",
												"Verified By",
												"Status",
												"Progress",
												"action",
										  ]
								}
								tbody={mappedData}
								roleId={roleId}
								donors={familyDonor}
								onChangeRole={onChangeRole}
							/>
						)}
					</Col>
				</Row>
			</div>
			<div className="d-flex justify-content-between align-items-center mt-3">
				<div className="d-flex justify-content-between align-items-center gap-5 mt-3">
					<Button
						disabled={!pagination.prev_page_url}
						onClick={() =>
							handlePageChange(pagination.current_page - 1)
						}
						className="bg-secondary border-0 ml-2"
						style={{ fontSize: "12px", fontWeight: "bold" }}
					>
						&laquo; Prev
					</Button>

					<Button
						disabled={!pagination.next_page_url}
						onClick={() =>
							handlePageChange(pagination.current_page + 1)
						}
						style={{
							backgroundColor: "#077834",
							fontSize: "12px",
							fontWeight: "bold",
						}}
					>
						Next &raquo;
					</Button>
				</div>

				<div className="d-flex align-items-center">
					<span>
						Page {pagination.current_page} of {pagination.last_page}
					</span>
					<div
						style={{
							position: "relative",
							display: "inline-block",
						}}
					>
						<input
							type="number"
							value={pagination.required_page}
							onChange={handleRequiredPageChange}
							onKeyDown={(e) =>
								e.key === "Enter" && handlePageInputSubmit()
							}
							placeholder="Page"
							style={{
								width: "100px",
								padding: "4px 30px 4px 8px",
								border: "1px solid #ccc",
								borderRadius: "4px",
								marginLeft: "10px",
							}}
						/>
						<button
							onClick={handlePageInputSubmit}
							style={{
								position: "absolute",
								right: "2px",
								top: "50%",
								transform: "translateY(-50%)",
								border: "none",
								background: "transparent",
								color: "#077834",
								cursor: "pointer",
								padding: "0 4px",
								fontSize: "14px",
							}}
						>
							<FontAwesomeIcon icon={faSearch} />
						</button>
					</div>
				</div>
			</div>
			{error && (
				<div
					className="text-danger mt-2 d-flex justify-content-end"
					style={{ fontSize: "13px" }}
				>
					{error}
				</div>
			)}
		</PageLayout>
	);
}
